<template>
  <div>
    <iframe id="iframeReport" name="iframeReport" style="height:0;width:0;"></iframe>
    <section ref="invoice" style="display:none;"  id="printableAssessmentArea">
      <v-card class="py-1 px-3 card">
        <v-banner class="subtitle" single-line >
          Assessment Report
        </v-banner>
        <v-row>
          <v-col> Name: {{assessmentData.userName}}</v-col>
          <v-col> Training: {{assessmentData.training}}</v-col>
          <v-col> Module Name: {{assessmentData.module}}</v-col>
        </v-row>
        <v-row>
          <v-col> Duration: {{assessmentData.durationMin}} Minutes</v-col>
          <v-col> StartTime: {{new Date(assessmentData.startTime).toLocaleTimeString()}}</v-col>
          <v-col> EndTime: {{new Date(assessmentData.endTime).toLocaleTimeString()}}</v-col>
        </v-row>
        <v-row>
          <v-col> Attempt: {{assessmentData.AttemptNo}}</v-col>
          <v-col>Result: {{assessmentData.result}} </v-col>
          <v-col>Score: {{assessmentData.score}}/{{assessmentData.total}} </v-col>
        </v-row>
        <v-divider></v-divider>
        <div v-for="(item, i) in assessmentData.allQuestions" :key="i">
          <v-row>
            <v-col> Question: {{i + 1}} {{item.question}}</v-col>
          </v-row>
          <v-row>
            <v-col v-for="(option, index) in item.allOptions" :key="index" cols="3" sm="3" md="3" offset-md="1" offset-sm="1">
            Option: {{index + 1}}- {{option.option}}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="3" sm="3" md="3">Selected Answer: {{item.selectedOption && item.selectedOption.option? item.selectedOption.option : 'NA'}}</v-col>
            <v-col cols="3" sm="3" md="3">Answer Is Correct: {{item.isCorrect}}</v-col>
          </v-row>
          <v-divider></v-divider>
        </div>
      </v-card>
    </section>
    <loading-icon :value="isLoading" />
  </div>
</template>

<script>
export default {
  name: 'OnlineClassList',
  props: ['trainingAssessmentAttemptData'],
  components: {
  },
  data () {
    return {
      prtHtml: '',
      assessmentData: {},
      isLoading: false
    }
  },

  computed: {
  },
  watch: {
  },
  async created () {
    this.assessmentData = this.trainingAssessmentAttemptData
  },
  methods: {
    errMsg (msg) {
      return this.$buefy.dialog.alert({
        message: msg,
        type: 'is-danger',
        hasIcon: true,
        animation: 'zoom-out',
        size: 'is-medium',
        icon: ' mdi-exclamation',
        iconPack: 'mdi',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>
<style scoped>
@media print {
  #printableArea,
  #printableArea * {
    visibility: visible;
  }
  #printableArea {
    position: absolute;
    left: 0;
    top: 0;
  }
  #printableArea1,
  #printableArea1 * {
    visibility: visible;
  }
  #printableArea1 {
    position: absolute;
    left: 0;
    top: 0;
  }
}
</style>
